<template>
  <div
    id="atlas-processing-application"
    class="v-center atlas-processing-application no-step-section"
  >
    <div>
      <Loader />
      <h4 class="text-center">
        <span
          v-if="applicationAccepted"
          class="accepted"
        >
          Your application has been accepted, please wait while we redirect you to the next step.
        </span>
        <span
          v-else
          class="processing"
        >
          We are processing your application, please do not hit back or refresh your browser.
        </span>
      </h4>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/ui/Loader.vue";
import { mapState } from "vuex";

export default {
  name: "Processing",

  components: {
    Loader,
  },

  computed: {
    ...mapState("underwriting", ["applicationAccepted"]),
  },
};
</script>

<style scoped>

</style>
